import { resetMapOptions, selectMapOptions, updateMapOption } from '../Map/mapSlice'
import { selectLocation, updateLocation } from './filtersSlice'
import { useSelector, useDispatch } from 'react-redux'
import useTranslation from 'hooks/useTranslation'
import { DISTANCE_LIST } from '../Map/mapUtils'
import Location from 'components/Location'
import Range from 'components/Range'

const locationBtn = <Location />

const Filter = ({ desktop = false, navigate }) => {
  const { distance, voivodship } = useSelector(selectMapOptions)
  const location = useSelector(selectLocation)

  const dispatch = useDispatch()
  const { t } = useTranslation('map')

  const updateRange = !!location && voivodship === undefined
  const showRange = updateRange || desktop

  return (
    <div className={`map__filter ${!showRange ? '--smaller' : ''}`}>
      <div className='filter__group group'>
        <div className='filter__location'>
          {locationBtn}
        </div>

        <div
          className='filter__input'
          onClick={() => {
            navigate('/mapsearch')
          }}>

          <input
            key={location}
            defaultValue={location}
            placeholder={t('searchStreet')} />

          {location
            ? <i
              className='icon icon--close s24'
              onClick={e => {
                e.stopPropagation()
                dispatch(updateLocation(''))
                dispatch(resetMapOptions())
              }} />
            : <i className='icon icon--search s24' />}
        </div>
      </div>

      {showRange && <div className='filter__group group'>
        <Range
          darkBG
          unit='km'
          value={distance || DISTANCE_LIST[0]}
          options={DISTANCE_LIST}
          updateValue={_distance => {
            if (updateRange) dispatch(updateMapOption({ distance: _distance }))
            else navigate('/mapsearch')
          }}
        />
      </div>}
    </div>
  )
}

export default Filter